import styled from "@emotion/styled";
import { MessageBar, MessageBarType } from "office-ui-fabric-react";
import React, { useContext } from "react";
import { Tooltip } from "../tooltip/Tooltip";
import { ColumnOptionsContext } from "./ColumnOptions";

type Props = {
  className?: string;
};

export const ViewDescription = ({ className }: Props) => {
  const { selectedView } = useContext(ColumnOptionsContext);

  return (
    <Tooltip
      content={selectedView?.userAppSettingDescription}
      styles={{
        root: {
          flex: 1,
          overflow: "hidden"
        }
      }}
    >
      <StyledMessageBar
        messageBarType={MessageBarType.info}
        className={className}
      >
        {selectedView?.userAppSettingDescription}
      </StyledMessageBar>
    </Tooltip>
  );
};

export const StyledMessageBar = styled(MessageBar)`
  background: ${p => p.theme.palette.neutralLighter};
  color: ${p => p.theme.palette.neutralPrimary};
  i {
    color: ${p => p.theme.palette.neutralPrimary};
  }
  .ms-MessageBar-innerText {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  width: 100%;
`;
